import { Middleware } from '../middleware'

export default {
  getAllPlaybooks(filter = {}) {  
    return new Middleware()
      .method('GET')
      .append(`/odin/playbooks`)
      .params({
        idCompany: filter?.idCompany,
        visibility: filter?.visibility,
        findBy: filter?.findBy,
        page: (filter.page ?? 1) - 1 === 0 ? undefined : (filter.page ?? 1) - 1,
        size: filter?.size,
      })
      .build()
  },
  getAllPlaybooksList() {  
    return new Middleware()
      .method('GET')
      .append(`/odin/playbooks/list`)
      .build()
  },

  getAssessments(idPlaybook) {
    return new Middleware()
      .method('GET')
      .append(`/odin/playbooks/${idPlaybook}/assessments`)
      .build()
  },

  getLessons(idPlaybook) {
    return new Middleware()
      .method('GET')
      .append(`/odin/playbooks/${idPlaybook}/lessons`)
      .build()
  },

  getConclusions(idPlaybook) {
    return new Middleware()
      .method('GET')
      .append(`/odin/playbooks/${idPlaybook}/conclusion`)
      .build()
  },
  async getPlaybook(id) {
    const playbook = {}
    const oops = err => console.error(err)
    await Promise.all([
      this.getAssessments(id)
        .then(({ data }) => (playbook.assessments = data))
        .catch(oops),
      this.getLessons(id)
        .then(({ data }) => (playbook.lessons = data))
        .catch(oops),
      this.getConclusions(id)
        .then(
          ({ data }) =>
            (playbook.conclusions = data ? data.conclusion : undefined)
        )
        .catch(oops),
      this.getDetailsPlaybook(id)
        .then(({ data }) => (playbook.general = data))
        .catch(oops),
      this.getVersions(id)
        .then(({ data }) => (playbook.versions = data))
        .catch(oops),
    ])

    return playbook
  },

  getVersions(idPlaybook) {
    return new Middleware()
      .method('GET')
      .append(`/odin/playbooks/${idPlaybook}/versions`)
      .build()
  },

  getDetailsPlaybook(id, idCompany) {
    return new Middleware()
      .method('GET')
      .append(`/odin/playbooks/${id}`)
      .params({
        idCompany,
      })
      .build()
  },
  createPlaybook(data) {
    return new Middleware()
      .method('POST')
      .append(`/odin/playbooks`)
      .setData(data)
      .build()
  },
  updatePlaybook(data, id) {
    return new Middleware()
      .method('PUT')
      .append(`/odin/playbooks/${id}`)
      .setData(data)
      .build()
  },

  updatePlaybookAssements(assessment) {
    return new Middleware()
      .method('PUT')
      .append(`/odin/playbooks/assessments/update/order`)
      .setData(assessment)
      .build()
  },

  updatePlaybookLessons(idPlaybook, data) {
    return new Middleware()
      .method('PUT')
      .append(`/odin/playbooks/${idPlaybook}/lessons`)
      .setData(data)
      .build()
  },

  updatePlaybookVersions(idPlaybook, data) {
    return new Middleware()
      .method('PUT')
      .append(`/odin/playbooks/${idPlaybook}/versions`)
      .setData(data)
      .build()
  },
  addPlaybookAssement(idPlaybook, data) {
    return new Middleware()
      .method('PUT')
      .append(`/odin/playbooks/${idPlaybook}/assessments`)
      .setData(data)
      .build()
  },
  updatePlaybookConclusion(idPlaybook, data) {
    return new Middleware()
      .method('PUT')
      .append(`/odin/playbooks/${idPlaybook}/conclusion`)
      .setData(data)
      .build()
  },

  deletePlaybookAssement(assessmentId) {
    return new Middleware()
      .method('DELETE')
      .append(`/odin/playbooks/assessments/${assessmentId}`)
      .build()
  },
  deletePlaybookVersion(id) {
    return new Middleware()
      .method('DELETE')
      .append(`/odin/playbooks/versions/${id}`)
      .build()
  },
  deletePlaybookLesson(lessonId) {
    return new Middleware()
      .method('DELETE')
      .append(`/odin/playbooks/lessons/${lessonId}`)
      .build()
  },
  deletePlaybook(playbookId) {
    return new Middleware()
      .method('DELETE')
      .append(`/odin/playbooks/${playbookId}`)
      .build()
  },
}
